import React, { useEffect, useState } from 'react';
import { Login } from '@milkmoovement/common_cognito_package';
import { onCognitoLogin } from '../../../auth/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getRegion, getHostname } from '../../../../utils';
import { showMessage } from '../../../store/actions';
import { fetchRegionFromBackend } from '../../../../utils/regionConfig';

const InternalLoginPage = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [region, setRegion] = useState(null);
    const [isLoadingRegion, setIsLoadingRegion] = useState(true);

    const hostname = getHostname(window);

    const providers = [];
    const internalProviderJSON = process.env.REACT_APP_INTERNAL_PROVIDER_MAP;
    const internalProvider = internalProviderJSON ? JSON.parse(internalProviderJSON) : {};
    providers.push(internalProvider);

    const authConfig = {
        domain: process.env.REACT_APP_OAUTH_DOMAIN,
        redirectSignIn: hostname,
        redirectSignOut: hostname,
        clientId: internalProvider.clientId,
    };

    const { error } = useSelector(({ persisted }) => persisted.auth.login);

    // Fetch region from backend on component mount
    useEffect(() => {
        const loadRegion = async () => {
            try {
                const fetchedRegion = await fetchRegionFromBackend();
                setRegion(fetchedRegion);
            } catch (err) {
                setRegion(getRegion(window.location.hostname));
            } finally {
                setIsLoadingRegion(false);
            }
        };
        loadRegion();
    }, []);

    useEffect(() => {
        if (error.message && error.name === 'RoleError') {
            dispatch(showMessage({ message: error.message }));
        }
    }, [error]);

    const handleNavigateForgotPassword = () => history.push({ pathname: '/forgot-password' });

    const handleNavigateLogin = () => history.push({ pathname: '/login' });

    const handleSucessfulLogin = async () => {
        dispatch(await onCognitoLogin());
    };

    // Show loading state while fetching region
    if (isLoadingRegion || !region) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return (
        <Login
            onSucessfulLogin={handleSucessfulLogin}
            onNavigateForgotPassword={handleNavigateForgotPassword}
            onNavigateLogin={handleNavigateLogin}
            metadata={{
                coreSystem: region,
            }}
            authConfig={authConfig}
            internalLoginRender
            providers={providers}
        />
    );
};

export default InternalLoginPage;
